<!-- 网销订单 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">销售单号</div>
                <el-input class="search-item" style="width: 250px" size="small" v-model.trim="searchData.osn" placeholder="销售单号"></el-input>
                <div class="search-name">订单状态</div>
                <el-select class="search-item" size="small" v-model="searchData.state">
                    <el-option v-for="item in orderStates" :key="item.TKey" :label="item.TValue" :value="item.TKey"></el-option>
                </el-select>

                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <!-- <el-button
          size="small"
          icon="el-icon-printer"
          class="search-btn btn-primary"
          >打印</el-button
        >-->
                <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                :row-key="getRowKeys"
            >
                <el-table-column width="50" type="selection" reserve-selection></el-table-column>
                <el-table-column width="200" prop="Osn" label="销售单号"></el-table-column>
                <el-table-column prop="OrderAmount" label="销售总额" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="ShipFee" label="运费" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" label="合计" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.OrderAmount + scope.row.ShipFee }}</template>
                </el-table-column>
                <el-table-column label="订单状态" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.StateName }}</template>
                </el-table-column>
                <el-table-column width="160" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button size="mini" type="text" @click="checkOrder(scope.row)" v-if="permission.checkOrderDetail">{{ permission.checkOrderDetail }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeStatisticsDialog" :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="sale"></statistics>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import statistics from '@/components/common/statistics.vue';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        statistics,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            searchData: {
                entpId: this.$util.getLocalStorage('userMsg').EntpId,
                osn: '',
                state: '',
                page: 1,
                limit: 15
            },
            tableData: null,
            tableDataLength: 0,
            orderStates: null,
            permission: null,
            multipleSelection: null,
            statisticsVisible: false
        };
    },
    mounted() {
        let history_searchParams = this.$util.getLocalStorage('searchParams');
        if (history_searchParams) {
            //判断查询参数是否有记录
            this.searchData = history_searchParams;
            this.$util.clearLocalStorage('searchParams'); //用完即删
        }
        this.permission = this.$util.getPermission('MyShareOrders');
        this.getSGoodsSalesOrderList();
        this.getSGoodsSalesOrderStates();
    },
    computed: {},
    watch: {},
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.OrderId;
        },
        //获取网销库存商品销售订单列表
        getSGoodsSalesOrderList() {
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetSGoodsSalesOrderList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.tableData = res.data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(err => {});
        },
        //获取订单状态分类
        getSGoodsSalesOrderStates() {
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetSGoodsSalesOrderStates'
                })
                .then(res => {
                    if (res.data) {
                        this.orderStates = res.data;
                    }
                })
                .catch(err => {});
        },
        checkOrder(order) {
            let searchParams = this.searchData;
            Vue.set(searchParams, 'dataIndex', 'buyReturnOut');
            this.$util.setLocalStorage('searchParams', searchParams); //保存当前查询参数，返回页面时使用

            this.$router.push('./siSalesOrdersDetails?orderId=' + order.OrderId);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeStatisticsDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getSGoodsSalesOrderList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getSGoodsSalesOrderList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getSGoodsSalesOrderList();
        },
        handleDBClick(event) {
            if (event) {
                this.checkOrder(event);
            }
        },
        resetSearch() {
            this.searchData = {
                entpId: this.$util.getLocalStorage('userMsg').EntpId,
                osn: '',
                state: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.$refs.multipleTable.clearSelection();
        }
    }
};
</script>
